import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import './Drawer.scss.js';
import { useId } from '../../utils/hooks/useId.js';
import { useAnimationStage } from '../../utils/hooks/useAnimationStage.js';

const bem = Bem.create("vai-drawer");
const Drawer = React.forwardRef((props, ref) => {
  const {
    dataTa = "vai-drawer",
    htmlId,
    width,
    height,
    children,
    anchor = "Right",
    animated = true,
    isOpen,
    underNavigation = false,
    style = {},
    onClick,
    className,
    overlay = false,
    onOverlayClick,
    ...rest
  } = props;
  const id = useId(htmlId, ["drawer"]);
  const stackingPosition = underNavigation ? "under" : "above";
  const classNames = addClass(className, bem.block(anchor.toLowerCase(), isOpen ? "" : "closed", animated ? "animated" : "", `stacked-${stackingPosition}-navigation`));
  const defaultWidth = anchor === "Left" || anchor === "Right" ? "200px" : "";
  const defaultHeight = anchor === "Top" || anchor === "Bottom" ? "200px" : "";
  const backgroundRef = React.useRef(null);
  const stage = useAnimationStage(isOpen);
  const displayBackground = overlay && isOpen && stage !== "hidden";
  React.useEffect(() => {
    if (overlay && onOverlayClick && backgroundRef.current !== null) {
      const backgroundEl = backgroundRef.current;
      const overlayClickCallback = () => onOverlayClick();
      backgroundEl.addEventListener("click", overlayClickCallback);
      return () => {
        backgroundEl.removeEventListener("click", overlayClickCallback);
      };
    }
    return void 0;
  }, [overlay, onOverlayClick, displayBackground]);
  const styles = {
    width: width || defaultWidth,
    height: height || defaultHeight,
    ...style
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    "data-ta-status": isOpen ? "visible" : "hidden",
    className: classNames,
    style: styles,
    onClick,
    ref,
    ...rest
  }, children), displayBackground && /* @__PURE__ */ React.createElement("div", {
    className: addClass(bem.element("background")(stage)),
    ref: backgroundRef,
    "data-ta": "vai-modal-background"
  }));
});

export { Drawer };
